// frontend/src/components/icons.tsx

import {
    Twitter,
    Github,
    Linkedin,
    type Icon as LucideIcon,
  } from "lucide-react"

  export type Icon = typeof LucideIcon

  export const Icons = {
    TwitterIcon: Twitter,
    GithubIcon: Github,
    LinkedinIcon: Linkedin,
  }